import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
export function Card({
  children,
  className = '',
  onClick,
  padding = 'md'
}: CardProps) {
  const paddingStyles = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  };
  return <div className={`bg-white/90 backdrop-blur-sm rounded-lg shadow-sm border border-gray-100/50 ${paddingStyles[padding]} ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''} ${className}`} onClick={onClick} data-id="element-4224">
      {children}
    </div>;
}